<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
    
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item"> <router-link class="nav-link" :to="{name:'CreateLivraison'}" style="color: #ffffff; font-weight: bold; font-family: Poppins, sans-serif !important;">Créer une commande</router-link></li>
          <li class="nav-item"> <router-link class="nav-link" :to="{name : 'user'}" style="color: #ffffff; font-weight: bold; font-family: Poppins, sans-serif !important;">Mon compte</router-link></li>
          <li class="nav-item"> <a class="nav-link" v-on:click="signout" style="color: #ffffff; font-weight: bold; font-family: Poppins, sans-serif !important;">Deconnexion</a></li>
        </ul>
      </div>

    </div>
  </nav>
</template>

<script>
import Swal from "sweetalert2";
import firebase from "firebase";
export default {
  data() {
    return {
      activeNotifications: true,
      user: {},
    };
  },
  async created() {
    this.user = this.$store.getters.user;
  },
  methods: {
    signout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: '<span style="color:green">Vous etes déconnecté</span>',
            showConfirmButton: false,
            timer: 2500,
          });
          this.$router.push("/");
        });
    },
  },
};
</script>
<style>
</style>
